export const hasStemsAccess = (CurrentUser: User): boolean => {
	const isHighValueUser =
		CurrentUser?.serviceTier === 'Account Managed' ||
		CurrentUser?.serviceTier === 'VIP'

	return CurrentUser?.isStaff || (CurrentUser?.canDownload && isHighValueUser)
}
